export default {
environment: 'development',
ENV: 'development',
};
